import React from 'react';
import {
    generateColumns,
    QuantityBasedTableRowInterface,
    useStyles,
} from './QuantityBased.utils';
import { useTranslation } from 'react-i18next';
import { quantityBasedEntityTransformer } from '../../../utils/transformers';
import DataGrid from '../../DataGrid/DataGrid';
import { PaginationMode } from '../../DataGrid/types';
import { DataServiceInterface } from '../DataService/DataService.utils';
import classNames from 'classnames';

const QuantityBased: React.VFC<DataServiceInterface> = ({
    currency,
    data,
    onPageChange,
    onPageSizeChange,
    initialPageSize,
    loading,
    rowCount,
    userDateTimeFormat,
    ratio,
    unit,
    className,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();
    const columns = generateColumns(t, currency, userDateTimeFormat, unit);

    const items: QuantityBasedTableRowInterface[] = data.map((item) =>
        quantityBasedEntityTransformer(item, ratio),
    );

    return (
        <DataGrid<QuantityBasedTableRowInterface>
            data={items}
            dataQa={'quantity-based-table'}
            loading={loading}
            columns={columns}
            rowCount={rowCount}
            paginationMode={PaginationMode.Server}
            onPageChange={onPageChange}
            onPageSizeChange={onPageSizeChange}
            initialPageSize={initialPageSize}
            classes={{
                header: classes.header,
                tableContainer: classNames(classes.tableContent, className),
            }}
        />
    );
};

export default QuantityBased;